document.addEventListener('click', function (e) {
  const proof = e.target.closest('.cm-proof');
  const anyPopup = document.querySelector('.cm-proof__popup:not([hidden])');

  // Klik på trigger
  const trigger = e.target.closest('.cm-proof__trigger');
  if (trigger) {
    const wrap = trigger.closest('.cm-proof');
    const popup = wrap.querySelector('.cm-proof__popup');

    const isOpen = !popup.hasAttribute('hidden');
    popup.toggleAttribute('hidden', isOpen);
    trigger.setAttribute('aria-expanded', String(!isOpen));
    return;
  }

  // Klik på kryds
  const closeBtn = e.target.closest('.cm-proof__close');
  if (closeBtn) {
    const wrap = closeBtn.closest('.cm-proof');
    const popup = wrap.querySelector('.cm-proof__popup');
    const trigger = wrap.querySelector('.cm-proof__trigger');

    popup.setAttribute('hidden', '');
    trigger?.setAttribute('aria-expanded', 'false');
    return;
  }

  // Klik udenfor en åben popup (luk)
  if (anyPopup && !anyPopup.contains(e.target) && !e.target.closest('.cm-proof__trigger')) {
    const wrap = anyPopup.closest('.cm-proof');
    anyPopup.setAttribute('hidden', '');
    wrap?.querySelector('.cm-proof__trigger')?.setAttribute('aria-expanded', 'false');
  }
});